import axios from 'axios'
import router from '@/router'
import {
	MessageBox,
	Message
} from 'element-ui'
import store from '@/store'
import {
	getToken
} from './auth.js'
// create an axios instance
const service = axios.create({
	baseURL: process.env.NODE_ENV == 'development' ? '/api' : process.env.VUE_APP_BASE_API,
	timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(
	config => {
		if (store.getters.token) {
			config.headers.token = getToken()
		}
		return config
	},
	error => {
		// do something with request error
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	response => {
		const res = response.data
		// 在该数组中的code会弹出提示，其他不会
		// const arr = [3002, 3000, 1002, 1003, 1004];
		// && res.code !== 3004 永辉让去掉
		if (res.code !== 200) {
			// Message({
			// 	message: res.msg || 'Error',
			// 	type: 'error',
			// 	duration: 5 * 1000
			// })
			if (res.code == 3010) {
				router.replace('/home')
			} else if (res.code === 1002 || res.code === 1003 || res.code === 1004) {
				store.dispatch('user/resetToken').then(() => {
					location.reload()
				})
			} else {
				Message({
					message: res.msg || 'Error',
					// type: 'error',
					duration: 5 * 1000
				})
			}
			// if (arr.includes(res.code)) {
			// 	// 在数组中存在
			// 	if (res.code == 3002 || res.code == 3000) {
			// 		router.replace('/home')
			// 	}
			// 	if (res.code === 1002 || res.code === 1003 || res.code === 1004) {
			// 		store.dispatch('user/resetToken').then(() => {
			// 			location.reload()
			// 		})
			// 	}
			// } else {
			// 	// 在数组中不存在
			// 	Message({
			// 		message: res.msg,
			// 		type: 'error',
			// 		duration: 5 * 1000
			// 	})
			// }
			// sendErrorToBackend(res || 'Error');
			return Promise.reject(res || 'Error')
		} else {
			// 这里是引入的翻译cdn 如果是请求接口成功后直接调用翻译
			// setTimeout(_=>{
			// 	translate.execute();
			// },100)
			if (res.code === 500) {
				Message({
					message: '网络出现点小问题，请刷新一下试试~',
					// type: 'error',
					duration: 5 * 1000
				})
				// sendErrorToBackend(res);
			} else {
				return res
			}
			// return res
		}
	},
	error => {
		if (error.message.includes('timeout')) {
			Message({
				message: '网络出现点小问题，请刷新一下试试~',
				// type: 'error',
				duration: 5 * 1000
			})
		} else {
			Message({
				message: error.message,
				// type: 'error',
				duration: 5 * 1000
			})
			return false
		}
		// sendErrorToBackend(error);
		return Promise.reject(error)
	}
)
// 将错误信息发送到后端的函数
const sendErrorToBackend = async (error) => {
	try {
		await axios.post('/log/error', {
			message: error.message,
			config: error.config,
			code: error.code,
			response: error.response ? error.response.data : null,
		});
	} catch (logError) {
		console.error('Error logging to backend:', logError);
	}
};
export default service